<template>
	<div class="history">
		<div class="sv-tabs horizontal-center bold18 mb-20">
			<div class="sv-tab" @click="isTeam = false">
				獲得コイン
				<hr class="sv-tab-underline" :style="{ 'visibility': isMemberTabUnderlineVisible }"/>
			</div>

			<div class="sv-tab" @click="isTeam = true">
				獲得いいね
				<hr class="sv-tab-underline" :style="{ 'visibility': isTeamTabUnderlineVisible }"/>
			</div>
		</div>

		<div class="mb-20 tm" style="font-size: 18px">過去7日間の獲得履歴を表示します。</div>

		<div v-show="!isTeam" class="tab-contents">
			<div v-if="coins.length > 0">
				<div class="coin-wrap" v-for="(row, index) in coins" :key="index" @click="$router.push({ name: '7coins', params: { coinPresentId: row.coin_id }})">
					<div class="coin-title horizontal-center">
						<img class="coin-image" :src="row.coin_image">
						<div class="coin-name bold18">{{ row.coin_name }}コイン</div>
					</div>

					<div class="coin-body horizontal-center">
						<common-avatar class="mr-5" :name="row.staff_name" :staffId="row.staff_id" :width="20" :image="row.staff_image"></common-avatar>
						<div class=""><span class="staff-name">{{ row.staff_name }}</span>さんから贈られました！</div>
					</div>

					<div class="coin-footer created">{{ row.created }}</div>
				</div>
			</div>
			<div v-else class="tm">コインはまだありません</div>
		</div>

		<div v-show="isTeam" class="tab-contents">
			<div v-if="likes.length > 0">
				<div class="like-wrap" v-for="(row, index) in likes" :key="index" @click="moveLikeDetail(row)">
					<div class="like-body horizontal-center">
						<img class="like-image" :src="require('@/assets/icons/like.svg')">
						<common-avatar class="ml-5 mr-5" :name="row.staff_name" :staffId="row.staff_id" :width="20" :image="row.staff_image"></common-avatar>
						<div class=""><span class="staff-name">{{ row.staff_name }}</span>さんがいいね！しました。</div>
					</div>

					<div class="like-footer created">{{ row.created }}</div>
				</div>
			</div>
			<div v-else class="tm">いいね！はまだありません</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.like-wrap,
.coin-wrap {
	background: #fff;
	border-radius: 10px;
	padding: 10px 20px;
	margin-bottom: 10px;

	.staff-name {
		font-weight: bold;
	}
}

.like-wrap {
	.like-body {
		margin-bottom: 10px;

		.like-image {
			width: 20px;
			height: 17px;
		}
	}
}

.coin-wrap {
	.coin-title {
		img {
			width: 40px;
			height: 41px;
			margin-right: 10px;
		}
	}

	.coin-body {
		margin: 5px 0 10px 0;
	}
}

.sv-tabs {
	justify-content: space-around;
	color: $brown;

	.sv-tab {
		cursor: pointer;

		hr.sv-tab-underline {
			background: $primary;
			height: 5px;
			width: 50px;
			margin: 5px auto 0;
			border-radius: 10px;
		}
	}
}

@media screen and (min-width: $breakPoint) {
	.history {
		margin-right: 160px;
		margin-left: 160px;
		
		.like-wrap,
		.coin-wrap {
			display: flex;
			justify-content: flex-start;
			padding: 15px 25px;
		}

		.coin-wrap {
			.coin-title {
				width: 380px;
			}

			.coin-image {
				width: 80px !important;
				height: 83px !important;
			}

			.coin-name {
				font-size: 26px;
			}
		}

		.like-wrap {
			.like-image {
				width: 80px;
				height: 70px;
				margin-right: 20px;
			}
		}

		/deep/ .avatar {
			img {
				width: 80px !important;
			}
		}

		.created {
			margin: auto 0 0 auto;
		}
	}
}
</style>

<script>
import CommonAvatar from '@/components/CommonAvatar'

export default {
	name: 'History',
	components: {
		CommonAvatar,
	},
	data () {
		return {
			isTeam: false,
			likes: [],
			coins: [],
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	computed: {
		isMemberTabUnderlineVisible: function() {
			return this.isTeam ? 'hidden' : 'visible';
		},
		isTeamTabUnderlineVisible: function() {
			return this.isTeam ? 'visible' : 'hidden';
		},
	},
	methods: {
		moveLikeDetail: function(row) {
			if (row.is_news) {
				this.$router.push({ name: 'news-view', params: { newsId: row.id, token: this.$consts.DUMMY_TOKEN }});
				return;
			} else {
				this.$router.push({ name: '7coins', params: { coinPresentId: row.id }});
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'histories';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.likes = res.data.likes;
				this.coins = res.data.coins;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
